import { createContext, useContext, useMemo, useState } from 'react'

import LoadingState from 'components/core/loading_state'

const LoadingStateContext = createContext({})

export const WithLoadingState = ({ children }) => {
  const [isLoaded, setLoaded] = useState(false)

  const contextValue = useMemo(() => ({ isLoaded, setLoaded }), [isLoaded])
  return (
    <LoadingStateContext.Provider value={contextValue}>
      {isLoaded || <LoadingState />}
      {children}
    </LoadingStateContext.Provider>
  )
}

export const useLoadingState = () => useContext(LoadingStateContext)
